import React from "react"

const Error = () => <h1>Ooops... Something went wrong</h1>

export default Error
